import React, {Component} from 'react';

import ReadyButton from '../../components/ReadyButton';
import AudioPlayer from '../../components/AudioPlayer';

import no_workingMemoryNumbersIntro from '../../assets/sounds/no/intros/workingmemory-numbers-intro.mp3';
import nn_workingMemoryNumbersIntro from '../../assets/sounds/nn/intros/workingmemory-numbers-intro.mp3';

import se_workingMemoryNumbersIntro from '../../assets/sounds/nn/intros/workingmemory-numbers-intro.mp3';
import de_workingMemoryNumbersIntro from '../../assets/sounds/de/intros/workingmemory-numbers-intro.mp3';
import de_workingMemoryNumbersIntroAdult from '../../assets/sounds/de/intros/workingmemory-numbers-intro-adult.mp3';

import strings from '../../strings';

class Intro extends Component {
	constructor(props) {
		super(props);
		const {testKeyType = null} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';

		switch (strings.getLanguage()) {
			case 'nn':
				this.audio = nn_workingMemoryNumbersIntro;
				break;
			case 'se':
				this.audio = se_workingMemoryNumbersIntro;
				break;
			case 'de':
				this.audio = isAdultFollowup
					? de_workingMemoryNumbersIntroAdult
					: de_workingMemoryNumbersIntro;
				break;
			case 'no':
			default:
				this.audio = no_workingMemoryNumbersIntro;
				break;
		}
	}

	render() {
		const {testKeyType = null, setReady} = this.props;
		const isAdultFollowup = testKeyType === 'adult-followup';

		const text = {
			intro1: isAdultFollowup
				? strings.wsn_intro_adult
				: strings.wsn_intro1,
			intro2: isAdultFollowup
				? strings.wsn_intro2_adult
				: strings.wsn_intro2,
			intro3: isAdultFollowup
				? strings.wsn_intro3_adult
				: strings.wsn_intro3,
			intro4: isAdultFollowup
				? strings.wsn_intro4_adult
				: strings.wsn_intro4,
		};

		return (
			<>
				<p>
					<AudioPlayer autoplay inline src={this.audio} />
					{text.intro1}
					<br />
					{text.intro2}
					<br />
					{text.intro3}
				</p>

				<p>{text.intro4}</p>

				<ReadyButton
					onReadyChange={setReady}
					isSpoonerism={false}
					isAdultTest={isAdultFollowup ? true : false}
				/>
			</>
		);
	}
}

export default Intro;
